import { JoinTerms, JoinTermsDetail, RawUiData, TermsDetail, TermsResponse } from 'src/types/type'

export const modifyUiData = (uiData: RawUiData) => ({
  layoutsInsert: {
    mainBg: uiData.mainBg,
    certs: uiData.certs,
    agency: uiData.agency,
  },
  layoutsConfirm: {
    confirmHover: uiData.confirmHover,
    submitBtn: uiData.submitBtn,
  },
  layoutsFooter: uiData.footer,
  layoutsTerms: uiData.terms,
  layoutsVerify: {
    verifyDir: uiData.verifyDir,
    cashSpace: uiData.cashSpace,
    verifyBtn: uiData.verifyBtn,
    cancelBtn: uiData.cancelBtn,
  },
})

/**
 * TermsData.[JoinTerms].Terms[].Title base64 Decoding
 */
export const convertTermsData = (termsData: TermsResponse): JoinTerms[] => {
  const termsResponseKeys = ['SKTTerms', 'KTTerms', 'LGUPTerms'] as const
  const copy = JSON.parse(JSON.stringify(termsData)) as TermsResponse

  for (const [key, value] of Object.entries(copy)) {
    if (termsResponseKeys.includes(key as keyof TermsResponse)) {
      value.Terms = value.Terms?.map((terms: JoinTermsDetail, index: number) => ({
        ...terms,
        Title: decodeURIComponent(escape(window.atob(terms.Title))),
        Required: terms.Required ?? 0,
        Order: Number(value.TermsOrder.charAt(index)),
      } as JoinTermsDetail)) ?? []
    }
  }

  return [
    copy.SKTTerms,
    copy.KTTerms,
    copy.LGUPTerms
  ]
}

/**
 * 약관 클릭을 했을때 해당 약관을 조회하기 위해 제목과 내용을 리턴해주는 함수
 * @param idx 약관번호
 * @param term getTermsData의 response : TermsType[]
 * @returns TermsTitle, termsContents
 */
export const getTermsDetail = (term: TermsDetail): TermsDetail => {
  return {
    TermsTitle: decodeURIComponent(escape(window.atob(term.TermsTitle))),
    TermsContents: decodeURIComponent(escape(window.atob(term.TermsContents)))
  }
}

export const getTermsAgree = (termsAgree: number[], telType: number, mvnoCheck: boolean) => {
  const arrAgree = [...termsAgree]
  // KT 알뜰폰 동의여부 Terms9 고정
  if (telType === 1 && mvnoCheck) {
    arrAgree[8] = 1
  }
  return arrAgree.join("")
}
